<template>
  <div v-loading="showLoading"
       class="esp_page_aside_wrap"
       :style="{padding: padding}"
       element-loading-background="rgba(255, 255, 255, 0.35)">
    <div class="esp_page_aside" :style="{backgroundColor: bgColor}">
      <div class="esp_aside" :style="{width: asideWidth}">
        <slot name="aside"></slot>
      </div>
      <div class="esp_content">
        <slot name="main"></slot>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'EspPageAside',
    data() {
      return {
        showLoading: false   // 显示加载框
      }
    },
    props: {
      asideWidth: {
        type: String,
        default: '200px'
      },
      padding: {
        type: String,
        default: '10px'
      },
      bgColor: {
        type: String,
        default: '#ffffff'
      },
      loading: {              // 是否显示加载框
        type: Boolean,
        default: false
      }
    },
    watch: {
      loading: {
        handler(newVal, oldVal) {
          this.showLoading = newVal;
        },
        immediate: true
      }
    }
  }
</script>

<style scoped lang="less">
  .esp_page_aside_wrap {
    height: 100%;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;

    .esp_page_aside {
      height: 100%;
      display: flex;
      border-radius: 2px;
      box-shadow: 0 0 3px rgb(0 0 0 / 13%);
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;

      & > div {
        display: flex;
        flex-direction: column;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        overflow: auto;
      }

      .esp_aside {
        border-right: 1px solid #e8e8e8;
      }

      .esp_content {
        flex: 1;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/EspPageAside.vue